(() => {
    // -------------------------------------------------------------------------
    // wdd — landing page namespace
    // -------------------------------------------------------------------------

    let lang = window.location.hostname.split(".").pop();
    if (!lang || lang === "uk" || lang === "com") lang = "en";
    if (!window.location.hostname || window.location.hostname === "127.0.0.1") lang = "cz";

    const langLower = lang.toLowerCase();
    const body = document.body;

    const wdd = {
        lang:      langLower.includes("-") ? langLower.split("-")[0] : langLower,
        localLang: (langLower.includes("-") && langLower.indexOf("-") < langLower.length - 2)
                       ? langLower.split("-")[1].toLowerCase()
                       : langLower,
        isMobile:  body.classList.contains("mobile"),
        isApp:     body.classList.contains("mobileapp"),
    };

    // -------------------------------------------------------------------------
    // getText — returns localised string by key
    // -------------------------------------------------------------------------
    wdd.getText = function (textProp) {
        const texts = {
            txt_noData: {
                cs: "Omlouváme se, nepodařilo se načíst data",
                sk: "Ospravedlňujeme sa, nepodarilo sa načítať dáta",
                de: "", at: "", en: "", hu: ""
            },
            txt_noCategoryData: {
                cs: "Omlouváme se, nepodařilo se načíst kategorie",
                sk: "Ospravedlňujeme sa, nepodarilo sa načítať kategórie",
                de: "", at: "", en: "", hu: ""
            },
            txt_noProductData: {
                cs: "Omlouváme se, nepodařilo se načíst produktová data",
                sk: "Ospravedlňujeme sa, nepodarilo sa načítať produktová dáta",
                de: "Leider konnten wir keine Produktdaten abrufen",
                at: "Leider konnten wir keine Produktdaten abrufen",
                en: "We're sorry, we were unable to retrieve product data",
                hu: "Sajnáljuk, nem sikerült letölteni a termékadatokat",
            },
        };

        if (!Object.hasOwn(texts, textProp)) {
            console.warn("wdd.getText: key not found:", textProp);
            return "";
        }

        return texts[textProp][wdd.localLang] || texts[textProp].cs;
    };

    // -------------------------------------------------------------------------
    // smoothScroll — smooth-scrolls anchor links with class js-smoothScroll
    //               and optionally scrolls immediately to targetEl
    // -------------------------------------------------------------------------
    wdd.smoothScroll = function (targetEl) {
        const scrollLinks = document.getElementsByClassName("js-smoothScroll");
        let offset = 110;

        if (document.querySelector(".top-buttons") && document.querySelector("#search")) {
            offset = document.querySelector(".top-buttons").offsetHeight
                   + document.querySelector("#search").offsetHeight;
        }

        const scrollOffset = wdd.isMobile ? offset : 0;

        for (const link of scrollLinks) {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                $("html, body").animate({ scrollTop: $(this.hash).offset().top - scrollOffset }, 500);
            });
        }

        if (targetEl) {
            $("html, body").animate({ scrollTop: $(targetEl).offset().top - scrollOffset }, 500);
        }
    };

    // -------------------------------------------------------------------------
    // buildCategoryList — renders items from JSON data into container
    // -------------------------------------------------------------------------
    wdd.buildCategoryList = function (data, container) {
        container.innerHTML = data
            .map(item => {
                const imgSrc = item.imgCode.startsWith("https://cdn.alza.")
                    ? item.imgCode
                    : `https://cdn.alza.cz/Foto/f2/${item.imgCode.trim().substring(0, 2)}/${item.imgCode.trim()}.jpg`;
                return `
                    <li class="lp-categories__item">
                    <a class="lp-categories__item-link" href="${item.url}">
                        <img class="lp-categories__item-image" src="${imgSrc}" alt="${item.name}">
                        <h3 class="lp-categories__item-heading">${item.name}</h3>
                        <p class="lp-categories__item-text">${item.description}</p>
                    </a>
                    </li>`;
            })
            .join("\n");
    };

    // -------------------------------------------------------------------------
    // loadSprite — fetches build/img/sprite.svg and injects it into <body>
    //              so icons can be referenced via <use href="#wdd-iconname">
    // -------------------------------------------------------------------------
    wdd.loadSprite = function () {
        fetch("https://image.alza.cz/Foto/or/lp/back-to-school/img/sprite-vendors.svg")
            .then(function (response) {
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                return response.text();
            })
            .then(function (svgText) {
                const div = document.createElement("div");
                div.setAttribute("aria-hidden", "true");
                div.style.cssText = "display:none;position:absolute";
                div.innerHTML = svgText;
                document.body.insertBefore(div, document.body.firstChild);
            })
            .catch(function (err) {
                console.warn("wdd: failed to load SVG sprite", err);
            });
    };

    // -------------------------------------------------------------------------
    // init — fetches category data and renders the tile list
    // -------------------------------------------------------------------------
    wdd.init = async function () {
        wdd.loadSprite();

        const dataUrl = `https://image.alza.cz/Foto/or/lp/back-to-school/data/data-${wdd.localLang}.json?_=${Date.now()}`;
        const categoriesEl = document.querySelector(".js-load-categories");
        const errorContainer = document.getElementById("js-categories");

        const showError = () => {
            errorContainer?.insertAdjacentHTML(
                "beforeend",
                `<p class="lp-error">${wdd.getText("txt_noCategoryData")}</p>`
            );
        };

        try {
            const response = await fetch(dataUrl);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            if (categoriesEl) wdd.buildCategoryList(data, categoriesEl);
        } catch (err) {
            console.warn("wdd: failed to load category data", err);
            showError();
        }
    };

    // Expose globally so the platform can reference wdd if needed
    window.wdd = wdd;

    wdd.init();
})();
